module.exports = __webpack_public_path__ + "static/media/email-logo.b9856350.svg";